import { ViewMode } from './ViewModeToggle';

const mapViewPageSize = 50;

// Return the page size to use for a ViewMode.
// 'undefined' indicates that the default page size is to be used.
export function getPageSize(viewMode?: ViewMode): number | undefined {
  return viewMode === ViewMode.Map ? mapViewPageSize : undefined;
}
